import React from 'react';
import { NavLink} from 'react-router-dom';


const Footer = (props) => {
  return (
    <nav id="footer" className="footer footer-default footer-fixed-down">
      <div className="container">
        <div className="footer">
        <div className="cgv">
        <NavLink to="/CGV" className="page-scroll">
                CGV
              </NavLink>
              <NavLink to="/mentions_legales" className="page-scroll">
               Mentions légales
              </NavLink>
          </div>
          <p className="footer">
          © Swaly Forme 2024
          </p>
        </div>

      </div>
    </nav>
  );
};

export default Footer;